import React from 'react';
import HlsVideoPlayer from './HlsVideoPlayer';
import { getStore, useExamSessionStore } from '../../../stores/StoreContext';
import { config } from '../../../config';
import VideoRenderer from '../VideoRenderer';

function HlsMedia() {
  const ExamSessionStore = getStore('examSessionStore');

  const canHaveLiveVideo = useExamSessionStore(
    (state) => state.canHaveLiveVideo
  );

  return (
    <>
      {/* If live video is not possible, then we need to include the video renderer, otherwise it is included with the webrtc playback... */}
      {!canHaveLiveVideo && (
        <VideoRenderer />
      )}

      <HlsVideoPlayer
        url={`${config.media.playback.baseUrl}/v1/${ExamSessionStore.getHlsAuthenticationToken()}/installs/${ExamSessionStore.installSid}/exams/${ExamSessionStore.examSid}/sessions/${ExamSessionStore.sessionSid}/playlist.m3u8`}
      />
    </>
  );
}

export default HlsMedia;
